import { NavigateFunction } from "react-router-dom";
import Swal from "sweetalert2";
import { IFetchError } from "../../../../../../types";
import Fetch from "../../../../../../utils/fetch";

interface Params {
  amount: number;
  setIsLoading: React.Dispatch<React.SetStateAction<boolean>>;
  navigate: NavigateFunction;
}

export default async function NagadInitialize(params: Params) {
  try {
    params.setIsLoading(true);
    const nagad_payment = await Fetch<{ callBackUrl: string }>({
      method: "POST",
      url: `${process.env.REACT_APP_BACKEND_URL}/api/b2b/wallet/payment/nagad/initialize`,
      body: {
        amount: params.amount,
      },
      navigate: params.navigate,
    });
    params.setIsLoading(false);
    window.open(nagad_payment.data.callBackUrl, "_self");
  } catch (error) {
    Swal.fire({
      title: (error as IFetchError).message,
      text: "Please Try Again",
      icon: "error",
      confirmButtonColor: "#253678",
    });
  }
}
